module.exports = __webpack_public_path__ + "static/media/delete.018ac6b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/delete.svg
// module id = 621
// module chunks = 0